// "Chế độ tập trung loyalty" cho demo/trình bày — chỉ ẩn hiển thị khỏi sidebar, route vẫn truy cập được, không đụng dữ liệu.
// Bật theo trình duyệt: localStorage.setItem('mantik_menu_focus','loyalty') rồi tải lại; tắt: localStorage.removeItem('mantik_menu_focus').
export function isLoyaltyFocus(): boolean {
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem('mantik_menu_focus') === 'loyalty';
  } catch {
    return false;
  }
}

// Khoá mục menu cấp org bị ẩn ở chế độ này (sự kiện/vé, sân, sơ đồ chỗ, nhóm đơn, nhãn, thanh toán, thẻ quà tặng, CMS, bên thứ ba, sổ đơn vị).
export const HIDDEN_IN_LOYALTY_FOCUS = new Set(['events', 'court', 'seating-plans', 'order-groups', 'tags', 'payments', 'giftcards', 'cms', 'thirdparty', 'thirdparty-group', 'unit-ledger']);
